/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF, PerspectiveCamera, OrthographicCamera } from '@react-three/drei'
import vigas from '../models/vigas.glb'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes } = useGLTF(vigas)
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-37.26, -15.47, 44.1]} rotation={[-Math.PI / 2, 0, 0]}>
        <mesh geometry={nodes.Asfalto.geometry} material={nodes.Asfalto.material} />
        <mesh geometry={nodes.Vigas.geometry} material={nodes.Vigas.material} />
        <mesh geometry={nodes.Hormig__n_2.geometry} material={nodes.Hormig__n_2.material} />
        <mesh geometry={nodes.Baranda.geometry} material={nodes.Baranda.material} />
        <mesh geometry={nodes.Pasto.geometry} material={nodes.Pasto.material} />
        <mesh geometry={nodes.Losa_aproximaci__n.geometry} material={nodes.Losa_aproximaci__n.material} />
        <mesh geometry={nodes.Texto.geometry} material={nodes.Texto.material} />
        <mesh geometry={nodes.Hormig__n1.geometry} material={nodes.Hormig__n1.material} />
      </group>
      <PerspectiveCamera makeDefault={false} far={103.39} near={58.96} fov={39.6} position={[19.64, 14.58, 47.39]} rotation={[-0.35, 0.42, 0.15]} />
      <PerspectiveCamera makeDefault={false} far={228099.06} near={228066.89} fov={49.5} position={[-11856.1, 30650.2, 230076]} rotation={[0.06, 0, -0.01]} />
      <PerspectiveCamera makeDefault={false} far={5665.9} near={5634.43} fov={49.5} position={[46009.4, 39383.2, -1572.01]} rotation={[Math.PI / 2, 0.8, 0]} />
      <PerspectiveCamera makeDefault={false} far={0.1} near={0} fov={49.5} position={[21510.9, 36881.3, -576.94]} rotation={[1.68, 0.71, -0.07]} />
      <PerspectiveCamera makeDefault={false} far={0.1} near={0} fov={49.5} position={[-3234.06, 39209.7, -1504.8]} rotation={[1.71, 0.66, -0.09]} />
      <PerspectiveCamera makeDefault={false} far={80685.02} near={80652.1} fov={49.5} position={[-49598.7, 64883.8, -924.51]} rotation={[-1.63, -0.81, 3.1]} />
      <PerspectiveCamera makeDefault={false} far={0.1} near={0} fov={49.5} position={[15593.2, 52578.7, -2130.15]} rotation={[-1.8, -1.37, 2.92]} />
      <PerspectiveCamera makeDefault={false} far={95517.48} near={95502.26} fov={49.5} position={[-98.69, 96366, -1878.24]} rotation={[-1.66, 0.11, -3.13]} />
      <PerspectiveCamera makeDefault={false} far={33.59} near={0} fov={39.6} position={[1.17, -0.2, 2.71]} rotation={[0.73, 0.79, 0.67]} />
      <OrthographicCamera makeDefault={false} far={129.39} near={97.66} position={[1.82, -0.44, 58.42]} rotation={[0, 0, Math.PI / 2]} />
      <OrthographicCamera makeDefault={false} far={25.15} near={0} position={[44.6, 2.13, 0.33]} rotation={[Math.PI / 2, Math.PI / 2, 0]} />
      <OrthographicCamera makeDefault={false} far={39.08} near={30.61} position={[1.86, 47.54, -0.08]} rotation={[-Math.PI / 2, 0, -Math.PI]} />
      <PerspectiveCamera makeDefault={false} far={12770.96} near={12739.23} fov={42.43} position={[0, 0, 12699.99]} rotation={[0, 0, Math.PI / 2]} />
      <PerspectiveCamera makeDefault={false} far={12770.96} near={12739.23} fov={42.43} position={[0, 0, 12699.99]} rotation={[0, 0, Math.PI / 2]} />
    </group>
  )
}
